import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
})

const CoresightSnackbar = props => {
  const { classes, handleClose, notification=[] } = props
  const open = notification.length ? true : false
  return (
    <Snackbar
      message={<span id="message-id">{notification}</span>}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      open={open}
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={handleClose}
          >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  )
}

export default withStyles(styles)(CoresightSnackbar)



// WEBPACK FOOTER //
// ./src/components/Snackbar.js